import { render, staticRenderFns } from "./Theorder.vue?vue&type=template&id=3aa13a94"
import script from "./Theorder.vue?vue&type=script&lang=js"
export * from "./Theorder.vue?vue&type=script&lang=js"
import style0 from "./Theorder.vue?vue&type=style&index=0&id=3aa13a94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports